'use client';

import { useIsBreakpoint, Breakpoint } from '@/hooks/useIsBreakpoint';
import { useHeadings, Heading } from './useHeadings';
import { useSidebarLayout, MAX_SIDEBAR_WIDTH } from './useSidebarLayout';
import { useScrollBehavior } from './useScrollBehavior';

interface UseJumpLinksOptions {
  minHeadingLevel: number;
  maxHeadingLevel: number;
}

export const useJumpLinks = ({ minHeadingLevel, maxHeadingLevel }: UseJumpLinksOptions) => {
  const isMobile = useIsBreakpoint(Breakpoint.LG);

  // heading collection from DOM
  const headings = useHeadings({ minHeadingLevel, maxHeadingLevel, isMobile });

  // sidebar positioning, sticky behavior
  const { sidebarLeft, sidebarWidth, fontScale, initialTop, stickyTop, isSticky, isFloating } = useSidebarLayout({
    isMobile,
  });

  // active section tracking, scroll actions
  const { activeId, listRef, scrollToHeading, scrollActiveIntoView } = useScrollBehavior({
    headings,
    stickyTop,
    isFloating,
  });

  return {
    headings,
    activeId,
    isFloating,
    isSticky,
    sidebarLeft,
    sidebarWidth,
    fontScale,
    initialTop,
    stickyTop,
    listRef,
    scrollToHeading,
    scrollActiveIntoView,
  };
};

// re-export types and constants
export type { Heading };
export { MAX_SIDEBAR_WIDTH };
